/**
 * GraphQL Queries for R0002 Toast metric aggregation
 *
 * Kept separate from auto-generated src/graphql/queries.js to prevent overwrites.
 * `amplify codegen` will also emit getR0002ToastData into that file; this module
 * is the one the report imports so codegen can never silently change the
 * selection set.
 *
 * @module clients/grm/views/R0002/ToastData/r0002ToastQueries
 */

/**
 * Fetch aggregated Toast data for both R0002 reporting periods in one call.
 *
 * `current` and `comparison` are AWSJSON strings. Each decodes to the two-page
 * structure the report expects:
 *
 *   [ { pageId: 'r0002_LSD_company',   data: [ { rowType, rowData } ] },
 *     { pageId: 'r0002_LSD_franchise', data: [ { rowType, rowData } ] } ]
 *
 * with '_empty' appended to a pageId when that page has no rows.
 *
 * Decode with getToastDataV2.decodePages, never a bare JSON.parse. AppSync
 * encodes an AWSJSON field itself, so the number of encodings depends on what
 * the resolver hands back — an array is encoded once, an already-stringified
 * array twice. The resolver returns arrays as of the AWSJSON fix, but a stale
 * deploy may still double-encode; decodePages handles both.
 *
 * @type {string}
 */
export const getR0002ToastData = /* GraphQL */ `
  query GetR0002ToastData($input: R0002ToastDataInput!) {
    getR0002ToastData(input: $input) {
      current
      comparison
      meta {
        curRowsScanned
        compRowsScanned
        curPages
        compPages
        storesMatched
        storesUnmatched
        curBytes
        compBytes
        durationMs
      }
    }
  }
`
